import { Auth } from "domain/model/Auth"
import pn, { query } from "core/utils/pn"
import { Server } from "core/utils/axios"
import {
  API_ADMIN,
  API_GET_ALL_COLLECTIONS,
  API_DATABASE,
  API_SYNC,
  API_GET_SYNCED_COLLECTIONS,
} from "core/constants/strings"
import { TypeDatabaseSync } from "domain/model/DatabaseSync"
import DatabaseSyncDataSource from "data/dataSource/Admin/DatabaseSyncDataSource"

const server = new Server()

export default class DatabaseSyncAPIDataSourceImpl implements DatabaseSyncDataSource {
  async databaseSync(auth: Auth, data: TypeDatabaseSync): Promise<any> {
    try {
      console.log("data", data)
      const response = await server.post(
        pn(API_ADMIN, API_DATABASE, API_SYNC),
        { backup_collections: data?.backupDatabases },
        {
          Authorization: `Bearer ${auth?.id_token}`,
        }
      )
      return response
    } catch (error) {
      return error
    }
  }

  async getAllCollectionNames(auth: Auth): Promise<any> {
    try {
      const response = await server.get(pn(API_ADMIN, API_DATABASE, API_GET_ALL_COLLECTIONS), {
        Authorization: `Bearer ${auth?.id_token}`,
      })
      return response
    } catch (error) {
      return error
    }
  }

  async getSyncedDatabaseCollections(auth: Auth): Promise<any> {
    try {
      const response = await server.get(pn(API_ADMIN, API_DATABASE, API_GET_SYNCED_COLLECTIONS), {
        Authorization: `Bearer ${auth?.id_token}`,
      })
      return response
    } catch (error) {
      return error
    }
  }
}
